export default __webpack_public_path__ + "static/media/serviceTypeImg4.05240732.svg";